import ViewDetails from "../../utils/utilities/ViewDetails";


import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import WorkHistoryRoundedIcon from '@mui/icons-material/WorkHistoryRounded';

// Tabs
import SettingsTab from "./Tabs/Settings";
// import SecurityTab from "./Tabs/Security";

  const tabContent = [
    {panel: "profile", content: <SettingsTab />},
    
  ]

const ViewVendorPortal = () => {

  const tabs = [
    {label: "Profile", icon: <ContactPageOutlinedIcon fontSize="small" />},
  ];

  return (
    <ViewDetails title="Vendor Portal" identifier="full_name" tabs={tabs} tabContent={tabContent} isProfile={true} url="vendor_integrations">

    </ViewDetails>
  )
};

export default ViewVendorPortal;